import { type ObjectValuesUnionType } from '../../../utils/typing';

export const GRChipStatuses = Object.freeze({
  PENDING: 'PENDING', // Bet pending for this achievement
  WON: 'WON', // Achievement won
  LOST: 'LOST', // Achievement
});
export type GRChipStatus = ObjectValuesUnionType<typeof GRChipStatuses>;

export type GRRoundBetsBetState = {
  status: GRChipStatus;
  betslipReference: string;
  points: number;
  counted: boolean;
};
